import React, { FC, useMemo } from "react";
import { useParams } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import { IChannel, ISelection } from "../helper";
import config from "../../../../config";
import { WebsiteChannel, EmailChannel, QrChannel } from "../common";
import { IVideo } from "../../../admin/videos/hooks/useFetchVideos";

interface Props {
  group: any;
  file: IVideo;
  iframeUrl: string;
  channel: IChannel;
  selections: Array<ISelection>;
  setSelections: (data: Array<any>) => void;
}

export const MediaIndividualView: FC<Props> = (props) => {
  const { projectId } = useParams();
  const { group, channel, file, iframeUrl } = props;

  const scriptTagProps = useMemo(
    () => ({
      class: "tdc2-single",
      bid: group?.brand?.id,
      fid: file.id,
      b: group?.brand?.slug,
      type: `text/javascript`,
      src: iframeUrl,
    }),
    [iframeUrl, group]
  );

  const formatLandingUrl = (source: string = "landing") =>
    `${config.EMBED_HOST}/brands/${group?.brand?.id}/${
      group?.brand?.slug ? group?.brand?.slug : "-"
    }/single/${file?.id}?source=${source}&p=${projectId}`;

  return (
    <Box className="flex flex-col xl:flex-row" gap={6}>
      <Box className="w-[300px] px-2 shrink-0">
        <script {...scriptTagProps} />
      </Box>

      <Box className="w-full px-2">
        <Typography gutterBottom component="div">
          <strong>{channel?.name}</strong>
        </Typography>

        {channel?.name === "Email/Text" && (
          <EmailChannel group={group} url={formatLandingUrl("landing")} />
        )}

        {channel?.name === "QR" && <QrChannel url={formatLandingUrl("qr")} />}

        {channel?.name === "Website" && (
          <WebsiteChannel
            iframeUrl={iframeUrl}
            scriptTagProps={scriptTagProps}
          />
        )}
      </Box>
    </Box>
  );
};
